import { gql } from '@apollo/client';
import integration from '../integration';

export const mutation = gql`
  mutation CloneIntegration($integrations_insert_input: integrations_insert_input!) {
    insert_integrations_one(object: $integrations_insert_input) {
      ...integration
      playbooks(order_by: { revision: desc }, limit: 1) {
        id
        revision
        playbookJson
        connectionJson
        vars
        pipeline_variables {
          id
          playbookId
          name
        }
      }
    }
  }
  ${integration}
`;

export function buildVariables({ newIntegrationId, newName, starterkitId, starterkitVersion, playbooks }) {
  // Sort by revision ascending so the DB trigger (set_playbook_version)
  // assigns revision numbers in the correct order.
  const sorted = [...(playbooks ?? [])].sort((a, b) => a.revision - b.revision);

  return {
    integrations_insert_input: {
      id: newIntegrationId,
      name: newName,
      starterkitId,
      starterkitVersion,
      ...(sorted.length > 0 && {
        playbooks: {
          data: sorted.map(pb => ({
            playbookJson: pb.playbookJson,
            connectionJson: pb.connectionJson,
            vars: pb.vars,
            pipeline_variables: {
              data: (pb.pipeline_variables ?? []).map(pv => ({
                name: pv.name,
              })),
            },
          })),
        },
      }),
    },
  };
}
